import { render, staticRenderFns } from "./SecurityformsGrid.vue?vue&type=template&id=050b38c9"
import script from "./SecurityformsGrid.vue?vue&type=script&lang=js"
export * from "./SecurityformsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports